import React, { useEffect, useState } from 'react'
import { APP_URL } from '../utils/config.js'

const FastenerCheckboxes = ({
  checkboxClassname,
  firstCheckboxClass,
  secondCheckboxClass,
  onClick = null,
  initialCheck,
  initialMirroredCheck,
  shouldCheckMirroredCheckbox = true,
  moveBreakFastener,
}) => {
  const [isChecked, setIsChecked] = useState(false)
  const [isMirrorChecked, setIsMirrorChecked] = useState(false)

  useEffect(() => {
    setIsChecked(initialCheck)
    setIsMirrorChecked(initialMirroredCheck)
  }, [initialCheck, initialMirroredCheck])

  const _toggleInputChecked = () => {
    setIsChecked(!isChecked)
    if (shouldCheckMirroredCheckbox) {
      setIsMirrorChecked(!isChecked)
    }
    if (onClick) {
      onClick(false)
    }
  }

  const _toggleMirrorInputChecked = () => {
    setIsMirrorChecked(!isMirrorChecked)
    if (shouldCheckMirroredCheckbox) {
      setIsChecked(!isMirrorChecked)
    }
    if (onClick) {
      onClick(true)
    }
  }

  const _onInputChange = () => {}

  return (
    <>
      <div
        onClick={_toggleInputChecked}
        id={`${checkboxClassname}-checkbox`}
        style={{ transform: 'translateX(' + moveBreakFastener + ')' }}
        className={`${checkboxClassname} ${firstCheckboxClass} ${isChecked ? 'checkbox-checked' : ''}`}
      >
        <img
          src={`${APP_URL}/wp-content/uploads/2021/10/244518073_281353593856796_4140750041269726971_n.png`}
        />
        <input
          onChange={_onInputChange}
          checked={isChecked}
          style={{ display: 'none' }}
          type={'checkbox'}
        />
      </div>
      <div
        id={`${checkboxClassname}-mirror-checkbox`}
        style={{ transform: 'translateX(' + moveBreakFastener + ')' }}
        onClick={_toggleMirrorInputChecked}
        className={`${checkboxClassname} ${secondCheckboxClass} ${isMirrorChecked ? 'checkbox-checked' : ''}`}
      >
        <img
          src={`${APP_URL}/wp-content/uploads/2021/10/244518073_281353593856796_4140750041269726971_n.png`}
        />
        <input
          onChange={_onInputChange}
          checked={isMirrorChecked}
          style={{ display: 'none' }}
          type={'checkbox'}
        />
      </div>
    </>
  )
}

export default FastenerCheckboxes
